import { LocationAggregate } from './location-aggregate.model';

export class Location {
  name: string;
  manufacturableAssets: string[];
  timezone: string;
  linkLabsGatewayId?: string;
  aggregate: { [dt: string]: LocationAggregate };

  constructor(name: string, timezone: string) {
    this.name = name;
    this.timezone = timezone;
    this.aggregate = {};
  }
}
